import { Component, Injector } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mj_Detail } from '../mj_detail/mj_detail';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { HatComponent } from '../component/hat';
import { LancetsComponent } from '../component/lancets';
import { LineSvgComponent } from '../component/linesvg';
import { UserStarComponent } from '../component/userstar';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from '../dashboard/dashboard';
import { DetailBadge } from '../detail_badge/detail_badge';
import { HrGraphCampionatiPage } from '../hr_graphcampionati/hr_graphcampionati';
import { HrProfiloUtentePage } from '../hr_profiloutente/hr_profiloutente';
import { TranslateService } from '@ngx-translate/core';
import { Select_Button } from '../select_button/select_button';

import { CambiaSquadraPage } from '../cambia-squadra/cambia-squadra';
import { HrSelezionaMjPage } from '../hr_selezionamj/hr_selezionamj';

/**
 * Generated class for the HrListUtentiPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
/*@NgModule({
  imports: [RoundProgressModule]
})*/
@Component({
  selector: 'page-hr_listutenti',
  templateUrl: 'hr_listutenti.html',
})
export class HrListUtentiPage extends Util {
  grafico: any = {};
  campionato: any;
  squadre: any[] = [];
  girone: any;
  index_click: any;
  table: any;
  lista_utenti: any = [];
  lista_utentiaux: any = [];
  myInput;
  shouldShowCancel = true;
  showDownloadTracciati: boolean = false;
  showEmailInvito: boolean = false;

  constructor(public navCtrl: NavController, public translate: TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController, hat: HatComponent, lancets: LancetsComponent, linesvg: LineSvgComponent, userstar: UserStarComponent) {
    super(injector, loading);
    // this.grafico = this.navParams.get('grafico');
    this.campionato = this.navParams.get('campionato');
    this.showDownloadTracciati = this.navParams.get('showDownloadTracciati');
    this.showEmailInvito = this.navParams.get('showEmailInvito');
    // this.squadre = this.navParams.get('squadre');
    console.log('campionato', this.campionato);
    // this.girone = this.navParams.get('girone');
    // this.index_click = this.navParams.get('index_click');
    // console.log('----',this.index_click);

    this.GetRequest('hr_squadre_campionato', this.campionato, true, false).then((sq) => {
      if (sq != null && sq['SquadraList'] != null)
        this.squadre = sq['SquadraList'];
    }).catch((err) => {
      console.error(err);
    })
    this.refreshpage();
    // this.timeout_loop();

  }

  getItems(ev: any) {
    // Reset items back to all of the items
    // this.refreshpage();
    this.lista_utenti = this.lista_utentiaux;
    // set val to the value of the searchbar
    const val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() !== '') {
      this.lista_utenti = this.lista_utenti.filter((item) => {
        return (item.nome.toLowerCase().indexOf(val.toLowerCase()) > -1 || item.cognome.toLowerCase().indexOf(val.toLowerCase()) > -1 || item.email === val);
      });
    }

    this.ordinaPerCognome(this.lista_utenti);
  }

  ordinaPerCognome(lista: any[]) {
    if (!Array.isArray(lista)) {
      return [];
    }

    return lista.sort((a, b) => {
      const cognomeA = ((a && a.cognome) ? a.cognome : '').toString().trim();
      const cognomeB = ((b && b.cognome) ? b.cognome : '').toString().trim();

      return cognomeA.localeCompare(cognomeB, 'it', { sensitivity: 'base' });
    });
  }

  onCancel(ev: any) {
    this.refreshpage();
  }

  change_team(utente) {

    const modal = this.modalCtrl.create(CambiaSquadraPage, { 'squadre': this.squadre, 'squadra_attuale': utente.squadra, 'utente': utente }, { showBackdrop: false, enableBackdropDismiss: false, cssClass: this.etheme.theme_selected });
    modal.onDidDismiss(data => {
      console.log(data);
      if (data) {
        this.PostRequest('hr_aggiorna_utente', '', { cid: this.campionato, squadraId: data.id, utenteId: utente.id }).then((res: any) => {
          console.log(res);
          this.refreshpage();
        }).catch((err) => {
          console.error(err);
        })
      }
    });
    modal.present();


    //modale con selezione della squadra, poi chiamata a hr_aggiorna_utente con id utente e id squadra
    // this.presentPopover({}, CambiaSquadraPage, 'Seleziona la nuova squadra dell\'utente',this.squadre).then((squadra) => {
    //   console.log(squadra);
    //   // this.PostRequest('hr_aggiorna_utente', {}, { cid: this.campionato, squadraId: squadra.id, utenteId: utente.id }).then((res: any) => {
    //   //   console.log(res);
    //   //   this.refreshpage();
    //   // }).catch((err) => {
    //   //   console.error(err);
    //   // })
    // });
  }

  disable_user(utente) {

    this.presentPopover({}, Select_Button, 'Sei sicuro di voler disattivare l\'utente?', ['si', 'annulla'], { cssClass: this.etheme.theme_selected }).then((livello) => {
      console.log(livello);
      if (livello == 'si') {
        this.PostRequest('hr_aggiorna_utente', '', { cid: this.campionato, disattiva: 1, utenteId: utente.id }).then((res: any) => {
          console.log(res);
          this.refreshpage();
        }).catch((err) => {
          console.error(err);
        })
      }


    });
    //         if (livello == v['SI']) {
    //           this.PostRequest('accettaSfida', m.id, false, false).then((res) => {
    //             this.open_questionario(res['Sfida']);
    //           }).catch((err) => {
    //             console.error(err);
    //           })
    //           this.livello = null;

    //         }

    //       })



    // this.PostRequest('hr_aggiorna_utente',{},{cid: this.campionato, disattiva:1, utenteId: utente.id}).then((res:any)=>{
    //   console.log(res);
    //   this.refreshpage();
    // }).catch((err)=>{
    //   console.error(err);
    // })
  }

  timeout_loop() {
    setTimeout(() => {
      this.refreshpage();
      this.timeout_loop();
    }, 1000 * 60 * 2);
  }

  refreshpage() {
    var req = this.campionato;
    // if(this.index_click == 0 || (this.index_click != undefined && this.index_click != ''))
    // req = +this.campionato+'/'+this.girone+'/'+this.index_click;
    // console.log(req);

    this.GetRequest('hr_utenti', req).then((res: any) => {
      // console.log(res);
      this.table = res;
      this.lista_utenti = res.UtenteList;
      this.lista_utentiaux = res.UtenteList;
      this.ordinaPerCognome(this.lista_utenti);
      this.ordinaPerCognome(this.lista_utentiaux);
      if (this.myInput != undefined && this.myInput != null) {
        this.getItems({ target: { value: this.myInput } });
      }
    }).catch((err) => {
      console.error(err);
    })
  }

  send_invite(utente) {
    //confirm sei sicuro di inviare l'invito?
     
      this.PostRequest('hr_send_invito','', { cid: this.campionato, uid: utente.id }).then((res: any) => {
        console.log(res);
      }).catch((err) => {
        console.error(err);
      })
    
  }


   confirm_invito(s) {
    const alert = this.alertCtrl.create({
      title: 'Invia invito',
      subTitle: 'Sei sicuro di voler inviare l\'invito a ' + s.cognome + ' ' + s.nome + '?',
      // cssClass: 'alertcambiasquadra',
      cssClass: this.etheme.theme_selected,
      buttons: [{
        text: 'Annulla',
        handler: data => {
          // console.log('Cancel clicked');
        }
      },
      {
        text: 'SI CONFERMO',
        handler: data => {
          // console.log('Saved clicked');
            this.send_invite(s);
        }
      }]
    });
    alert.present();
 
  }


  // export(){
  //   var req = this.grafico.id+'/'+this.campionato+'/'+this.girone;
  //   if(this.index_click == 0 || (this.index_click != undefined && this.index_click != ''))
  //     req = this.grafico.id+'/'+this.campionato+'/'+this.girone+'/'+this.index_click;
  //   this.GetRequest('hr_esporta_grafico',req).then((x:any)=>{
  //     // console.log(x);
  //     if (x != null && x.base64 != null) {
  //       const linkSource = `data:application/vnd.ms-excel;base64,${x.base64}`;
  //       const downloadLink = document.createElement("a");
  //       const fileName = "esportazione_dati_eydlab.xls";

  //       downloadLink.href = linkSource;
  //       // downloadLink.target = '_blank';
  //       downloadLink.download = fileName;
  //       downloadLink.click();
  //     }
  //   }).catch((err)=>{
  //     console.error(err);
  //   })
  // }
  open_profiloutente(utente) {
    this.navCtrl.push(HrProfiloUtentePage, { utente: utente, campionato: this.campionato,showDownloadTracciati: this.showDownloadTracciati });
  }



  back() {

    this.navCtrl.pop({ animate: false });

  }


  scarica_tracciato(utente) {
    let uid = utente.id;
    // let cid = this.campionato;
    // let mjids = [];
    // let mjl = [];

    this.GetRequest('microJourneyUtenteList', this.campionato + '/' + uid).then(data => {

      let mjl = data['MicroJourneyList'];
      if (mjl.length == 0) {
        // this.presentToast('Questo utente non è iscritto a nessun percorso', 'danger', 'bottom', 3000);
        this.showBasicAlert(' ','Questo utente non è iscritto a nessun percorso');
        return;
      }
      const modal = this.modalCtrl.create(HrSelezionaMjPage, { 'mj': mjl }, { showBackdrop: false, enableBackdropDismiss: false, cssClass: this.etheme.theme_selected });
      modal.onDidDismiss(data => {
        console.log(data);
        if (data) {
          this.PostRequest('hr_tracciato', '', { cid: this.campionato, mjids: data.mjids, uid: utente.id }).then((res: any) => {
            console.log(res);
            if (res != null && res.base_64 != null) {
              const linkSource = `data:${res.type};base64,${res.base_64}`;
              const downloadLink = document.createElement("a");
              const fileName = res.nome;

              downloadLink.href = linkSource;
              // downloadLink.target = '_blank';
              downloadLink.download = fileName;
              downloadLink.click();
            }

          }).catch((err) => {
            console.error(err);
          })
        }
      });
      modal.present();

    }).catch((e) => {
      console.error(e)
    })
    // console.log('scarica tracciato', utente);
  }

}



// WEBPACK FOOTER //
// ./src/pages/hr_listutenti/hr_listutenti.ts